export default __webpack_public_path__ + "static/media/whatsappSlide8.3da3a8b6.svg";